export default {"src":"/_next/static/media/message.d141e3b3.svg","height":16,"width":20};